export interface LetterRequestCustomer_Funds_Interface {
  id:number,
  title_id:number,
  customer:string,
  code:string,
  code2:string,
  src:string,
  title:string,
  dsc:string,
  price:number,
  status:number,
  price_date:String,
  subdate:String,
  answer:String,
  username:String,
  del:boolean,
  visible:boolean,
}

export function Empty_LetterRequestCustomer_Funds_Interface():LetterRequestCustomer_Funds_Interface{
  return{
    id:0,
    title_id:0,
    customer:'',
    code:'',
    code2:'',
    src:'',
    title:'',
    dsc:'',
    price:0,
    status:0,
    price_date:'',
    answer:'',
    subdate:'',
    username:'',
    del:false,
    visible:false,
  }
}
